import './Card.css'

/**
 * Surface container. `as` lets a card carry the right semantics (e.g. <li>,
 * <article>) without changing its appearance.
 */
export function Card({
  as: Tag = 'div',
  size = 'md',
  floating = false,
  hoverable = false,
  className = '',
  children,
  style,
  onClick,
  ...rest
}) {
  return (
    <Tag
      // `className` is merged rather than spread through `rest`: a caller
      // passing one there would replace the card's own classes and strip the
      // surface off it. Page-level decoration (the landing's `.u-sch`) hangs
      // off this without the design system having to know about it.
      className={
        'u-card' +
        (size === 'lg' ? ' u-card--lg' : '') +
        (floating ? ' u-card--float' : '') +
        (hoverable ? ' u-card--hover' : '') +
        (className ? ' ' + className : '')
      }
      style={style}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export default Card
